<template>
  <v-container>
    <v-card>
      <v-card-title
          class="grey lighten-4 py-4 title"
      >
        Create BuyBack Request
      </v-card-title>
      <v-container grid-list-sm class="pa-4">
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field
                prepend-icon="insert_invitation"
                placeholder="Request Date"
                readonly
                v-model="requestDate"
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-select
                :items="$store.state.RequestStatus"
                label="Request Status"
                v-model="requestStatus"
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-text-field
                label="Requester"
                :value="requester"
                v-model="requester"
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-select
                :items="$store.state.RequestType"
                label="Request Type"
                v-model="requestType"
            ></v-select>
          </v-flex>
          <v-flex xs6>
            <v-text-field
                label="Request Name"
                :value="name"
                v-model="name"
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-select
                :items="$store.state.vendors"
                label="Vendor"
                item-text="vendorName"
                v-model="vendor"
            ></v-select>
          </v-flex>          
          <v-flex xs12>

            <v-data-table
                :headers="headers"
                :items="items"
                disable-initial-sort
                hide-actions
            >
              <template v-slot:items="props">
                <template v-if="editingRow !== props.item.requestLineId">
                  <td class="justify-center layout px-0" nowrap>
                    <v-icon
                        small
                        class="mr-2"
                        @click="editingRow = props.item.requestLineId"
                    >
                      edit
                    </v-icon>
                    <v-icon
                        small
                        @click="deleteRow(props.item)"
                    >
                      delete
                    </v-icon>
                  </td>
                  <td class="text-xs-right">{{ props.item.itemId }}</td>
                  <td class="text-xs-right">{{ props.item.quantityRequested }}</td>
                  <td class="text-xs-right">{{ props.item.price }}</td>
                </template>
                <template v-if="editingRow === props.item.requestLineId">
                  <td class="justify-center layout px-0" nowrap>
                    <v-icon
                        small
                        class="mr-2"
                        @click="editingRow = -1"
                    >
                      edit
                    </v-icon>
                    <v-icon
                        small
                        @click="deleteRow(props.item)"
                    >
                      delete
                    </v-icon>
                  </td>
                  <td>
                    <PartNumberLookup v-model="props.item.itemId" v-on:input="itemChanged"/>
                  </td>
                  <td>
                    <v-text-field
                        v-model="props.item.quantityRequested"
                        :rules="[validateNumber]"
                        label="Edit"
                        single-line
                        reverse
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                        v-model="props.item.price"
                        :rules="[validateNumber]"
                        label="Edit"
                        single-line
                        reverse
                    ></v-text-field>
                  </td>

                </template>
              </template>
            </v-data-table>

          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-btn flat color="primary" @click="addRow">Add Row</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="$emit('close')">Cancel</v-btn>
        <v-btn flat @click="$emit('save', {
            requestLines: items,
            requester: getUsername(),
            requestDate,
            requestType,
            requestStatus,
            name,
            vendor
          })"
          v-if="modelOpened"
          >Save</v-btn><!-- NOTE the v-if on this button is only to trigger the beforeUpdate method to fire when the modal is displayed. -->
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
  import moment from 'moment';
  import PartNumberLookup from './PartNumberLookup';

  export default {
    components: {
      PartNumberLookup
    },
    data() {
      return {
        editingRow: -1,
        requestType: null,
        requestStatus: 'New',
        requestDate: moment().format('L'),
        max25chars: v => v.length <= 25 || 'Input too long!',
        validateNumber: v => !Number.isNaN(v),
        props: ['saveCallback'],
        requester: '',
        headers: [
          {text: 'Actions', align: 'center', width: '100px'},
          {text: 'Item ID', align: 'right', value: 'itemId', width: '300px'},
          {text: 'Qty Requested', align: 'right', value: 'quantityRequested'},
          {text: 'Price', align: 'right', value: 'price'},
        ],
        items: [],
        name: undefined,
        vendor: undefined,
      };
    },
    props: ['modelOpened'],
    methods: {
      itemChanged(itemId) {
        console.log('$$ Item changed:', itemId);
        const itemIndex = this.items.findIndex((i) => i.itemId === itemId);
        const partIndex = this.$store.state.partNumbers.findIndex((i) => i.itemId === itemId);

        if (itemIndex >=0 && partIndex >= 0) {
          this.items[itemIndex].price = Number.parseFloat(this.$store.state.partNumbers[partIndex].ciscoRefreshListPrice);
        }
      },
      getUsername() {
        if (this.$store &&
          this.$store.state &&
          this.$store.state.user &&
          this.$store.state.user.attributes
        ) {
          return this.$store.state.user.attributes.name;
        }

        return 'unknown';
      },
      addRow() {
        const requestLineId = new Date().getTime();
        this.items.push(
          {
            requestLineId,
            itemId: 'item',
            quantityRequested: 0,
            price: 0.00,
            ecoStatus: 'Pending',
          }
        );
        this.editingRow = requestLineId;
      },
      close () {
        // eslint-disable-next-line no-console
        console.log('Dialog closed')
      },
      deleteRow(item) {
        // eslint-disable-next-line no-console
        console.log('delete row:', item.requestLineId);
        const index = this.items.findIndex((i) => i.requestLineId === item.requestLineId);
        this.items.splice(index, 1);
        // eslint-disable-next-line no-console
        console.log('index:', index, 'items:', this.items);

      }
    },
    beforeUpdate() {
      console.log('beforeUpdate');
      console.log('user:', this.$store.state.user.attributes.name);
      this.requester = this.getUsername();
    }
  }
</script>

<style>

</style>
